"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var RouteChangeHandler_1 = __importDefault(require("../helpers/RouteChangeHandler"));
var utm_1 = require("../../redux/utm");
var _helpers_1 = require("../../helpers");
var react_1 = __importDefault(require("react"));
var react_gtm_module_1 = __importDefault(require("react-gtm-module"));
var react_helmet_1 = require("react-helmet");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var redux_1 = require("redux");
var redux_devtools_extension_1 = require("redux-devtools-extension");
var styled_components_1 = require("styled-components");
require("../../scss/index.scss");
var defaultTheme_1 = __importDefault(require("../../theme/defaultTheme"));
var store = redux_1.createStore(utm_1.utmReducer, redux_devtools_extension_1.composeWithDevTools());
var GlobalStyle = styled_components_1.createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  body, html, p, span, input, label, button {\n    font-family: ", ";\n  }\n  h1, h2, h3, h4, h5, h6 {\n    font-family: ", ";\n  }\n"], ["\n  body, html, p, span, input, label, button {\n    font-family: ", ";\n  }\n  h1, h2, h3, h4, h5, h6 {\n    font-family: ", ";\n  }\n"])), function (_a) {
    var DEFAULT_FONT = _a.DEFAULT_FONT;
    return DEFAULT_FONT;
}, function (_a) {
    var HEADLINE_FONT = _a.HEADLINE_FONT;
    return HEADLINE_FONT;
});
var Provider = function (_a) {
    var children = _a.children, _b = _a.theme, theme = _b === void 0 ? {} : _b, gtmId = _a.gtmId;
    window.addEventListener('load', function () {
        if (gtmId) {
            react_gtm_module_1.default.initialize({ gtmId: gtmId });
        }
        // Timeout so all of those analytics scripts dont block the rendering which kills our pagespeed
    });
    var mergedTheme = _helpers_1.merge(defaultTheme_1.default, theme);
    var fontSettings = {
        HEADLINE_FONT: mergedTheme.fonts.find(function (item) {
            return item.types.includes('HEADLINE');
        }),
        DEFAULT_FONT: mergedTheme.fonts.find(function (item) {
            return item.types.includes('DEFAULT');
        })
    };
    return (react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement(react_redux_1.Provider, { store: store },
            react_1.default.createElement(styled_components_1.ThemeProvider, { theme: mergedTheme },
                react_1.default.createElement(RouteChangeHandler_1.default, null),
                react_1.default.createElement(react_helmet_1.Helmet, null,
                    mergedTheme.fonts.map(function (item, i) { return (react_1.default.createElement("link", { key: i, href: "https://fonts.googleapis.com/css2?family=" + item.fontFamily + ":" + item.fontWeight + "&display=swap", rel: "stylesheet" })); }),
                    react_1.default.createElement("link", { href: "https://fonts.googleapis.com/icon?family=Material+Icons", rel: "stylesheet" })),
                react_1.default.createElement(GlobalStyle, { HEADLINE_FONT: fontSettings.HEADLINE_FONT.fontFamily, DEFAULT_FONT: fontSettings.DEFAULT_FONT.fontFamily }),
                children))));
};
exports.default = Provider;
var templateObject_1;
//# sourceMappingURL=Provider.js.map